<div class="right-drawer-rail">
	<!-- Two wrappers per button, and they can't be merged: `railSlot` pins its final
	     `transform` inline on .rail-item, which would overwrite .rail-tuck's slide
	     (and the button's own :hover scale, which is why neither is on the button).
	     The trigger has to sit on .rail-item, the element `@if` drops — on a
	     descendant of it, only the entrance would ever play. -->
	<div class="rail-item">
		<div class="rail-tuck">
			<button type="button" class="rail-button"
					(click)="closed.emit()"
					[tooltip]="'global.close' | translate" tooltipPosition="left" [tooltipOffset]="5">
				<img src="assets/icons/close.svg" alt="" class="rail-icon" width="10" height="10">
			</button>
		</div>
	</div>

	@if (showBack()) {
		<div class="rail-item" [@railSlot]="slotMode()">
			<div class="rail-tuck">
				<button type="button" class="rail-button"
						(click)="showBackView() ? wentBackView.emit() : wentBack.emit()"
						[tooltip]="'button.goBack' | translate" tooltipPosition="left" [tooltipOffset]="5">
					<img src="assets/icons/flip-backward.svg" alt="" class="rail-icon" width="16" height="16">
				</button>
			</div>
		</div>
	}
	@if (showComment()) {
		<div class="rail-item" [@railSlot]="slotMode()">
			<div class="rail-tuck">
				<button type="button" class="rail-button"
						(click)="commentsToggled.emit()"
						[tooltip]="'page.roles.permissions.actions.comment' | translate" tooltipPosition="left" [tooltipOffset]="5">
					<img src="assets/icons/message-text-square-02.svg" alt="" class="rail-icon" width="16" height="16">
					@if (unreadComments() > 0) {
						<span class="rail-badge"></span>
					}
					@if (commentsCount() > 0) {
						<span class="total-comments flex-center font-S fw-700">{{ commentsCount() }}</span>
					}
				</button>
			</div>
		</div>
	}
</div>
